__turbopack_context__.v({
  "body": "network-module__VigwSG__body",
  "center": "network-module__VigwSG__center",
  "chip": "network-module__VigwSG__chip",
  "clipL": "network-module__VigwSG__clipL",
  "clipR": "network-module__VigwSG__clipR",
  "controls": "network-module__VigwSG__controls",
  "crowded": "network-module__VigwSG__crowded",
  "dash": "network-module__VigwSG__dash",
  "dim": "network-module__VigwSG__dim",
  "edge": "network-module__VigwSG__edge",
  "edges": "network-module__VigwSG__edges",
  "elabel": "network-module__VigwSG__elabel",
  "facts": "network-module__VigwSG__facts",
  "fadeIn": "network-module__VigwSG__fadeIn",
  "fs": "network-module__VigwSG__fs",
  "go": "network-module__VigwSG__go",
  "group": "network-module__VigwSG__group",
  "groupHead": "network-module__VigwSG__groupHead",
  "groupMore": "network-module__VigwSG__groupMore",
  "group_": "network-module__VigwSG__group_",
  "head": "network-module__VigwSG__head",
  "ic": "network-module__VigwSG__ic",
  "kind": "network-module__VigwSG__kind",
  "legend": "network-module__VigwSG__legend",
  "links": "network-module__VigwSG__links",
  "lit": "network-module__VigwSG__lit",
  "main": "network-module__VigwSG__main",
  "measuring": "network-module__VigwSG__measuring",
  "more": "network-module__VigwSG__more",
  "net": "network-module__VigwSG__net",
  "nm": "network-module__VigwSG__nm",
  "node": "network-module__VigwSG__node",
  "nodeIn": "network-module__VigwSG__nodeIn",
  "panel": "network-module__VigwSG__panel",
  "panelClose": "network-module__VigwSG__panelClose",
  "panelSub": "network-module__VigwSG__panelSub",
  "panelTitle": "network-module__VigwSG__panelTitle",
  "pannable": "network-module__VigwSG__pannable",
  "person": "network-module__VigwSG__person",
  "pill": "network-module__VigwSG__pill",
  "pillCall": "network-module__VigwSG__pillCall",
  "pillCalling": "network-module__VigwSG__pillCalling",
  "pillHint": "network-module__VigwSG__pillHint",
  "role": "network-module__VigwSG__role",
  "round": "network-module__VigwSG__round",
  "sb": "network-module__VigwSG__sb",
  "scrolls": "network-module__VigwSG__scrolls",
  "sel": "network-module__VigwSG__sel",
  "side": "network-module__VigwSG__side",
  "sizer": "network-module__VigwSG__sizer",
  "stage": "network-module__VigwSG__stage",
  "stageWrap": "network-module__VigwSG__stageWrap",
  "stand": "network-module__VigwSG__stand",
  "withPanel": "network-module__VigwSG__withPanel",
});
